import * as classnames from "classnames";

import { Avatar } from "../index";

/**
 * Prop interface
 */
export interface ApplicantExamHeaderProps {
  tutorial?: boolean;
  orgImageUrl?: string;
  orgName: string;
  title: string;
  className?: string;
}

/**
 * React Component
 */
export default function ApplicantExamHeader({
  tutorial,
  title,
  orgName,
  orgImageUrl,
  className,
}: ApplicantExamHeaderProps) {
  const rootStyle = classnames("code-c-applicant-exam-header", {
    [`${className}`]: Boolean(className),
  });

  return (
    <div className={rootStyle}>
      <Avatar
        className="code-c-applicant-exam-header__image"
        src={orgImageUrl}
        size="large"
      />
      <div>
        <div className="code-c-applicant-exam-header__orgname">
          {tutorial ? "Tutorial" : orgName}
        </div>
        <div className="code-c-applicant-exam-header__title">{title}</div>
      </div>
    </div>
  );
}
